// Types for /process/* and small helpers shared by the process pages.

export type Period = { year: number; month: number }
export type Step = "allocation" | "payroll" | "division" | "unit" | "close"
export type Deadline = { step: Step; day: number; label: string; passed: boolean; today: boolean }
export type Cycle = {
  today: [number, number, number]
  period: Period
  periodLabel: string
  managed: boolean
  deadlines: Record<Step, Deadline>
  settings: ProcessSettings
}
export type ProcessSettings = {
  allocationEnd: number; payrollEnd: number; divisionEnd: number; unitEnd: number; closeDay: number
  forecastWindowDays: number; processStart: Period
}
export type ForecastWindow = { open: boolean; fiscalYear: number; round: number; start: [number, number, number]; end: [number, number, number]; endLabel: string; manual?: boolean }
export type AllocationState = "missing" | "draft" | "rejected" | "submitted" | "div_approved" | "approved"
export type Task = {
  key: string
  kind: "allocation" | "division" | "unit" | "payroll" | "costs" | "close" | "forecast"
  title: string
  detail: string
  count?: number
  due: string | null
  overdue: boolean
  done: boolean
  link: string
}
export type TasksResponse = {
  cycle: Cycle
  closed: boolean
  forecast: ForecastWindow
  allocation: { id: number | null; state: AllocationState; period: Period } | null
  tasks: Task[]
}

const PERSIAN = "۰۱۲۳۴۵۶۷۸۹"
/** Server labels carry Latin digits ("5 آبان 1405"); show them in Persian. */
export const fa = (text: string | number) => String(text).replace(/\d/g, (digit) => PERSIAN[Number(digit)]!)

export const STATE_LABEL: Record<AllocationState, string> = {
  missing: "ثبت نشده",
  draft: "پیش‌نویس",
  rejected: "برگشت خورده",
  submitted: "منتظر تأیید مدیر واحد",
  div_approved: "منتظر تأیید کسب‌وکار",
  approved: "تأیید نهایی",
}
